import { render, staticRenderFns } from "./OSmsActionComp.vue?vue&type=template&id=7c7b829e&"
import script from "./OSmsActionComp.vue?vue&type=script&lang=js&"
export * from "./OSmsActionComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports